import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/modules/shared/shared-module";
import { ChallengesRoutingModule } from "./challenges-roting.module";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { MatChipsModule } from "@angular/material/chips";
import {
  ChallengesListingPageComponent,
  CreateNewChallengeDetailsComponent,
  MilestoneSummaryViewComponent,
  SettingUpNewMilestoneConfigComponent,
} from "./pages";
import {
  ChallengesMilestoneConfigComponent,
  ChallengesMilestoneConfigSetUpComponent,
  ChallengesRewardConfigComponent,
  ChallengeTypeSelectionComponent,
  GetChallengeDetailsPageComponent,
  GetTimeBasedChallengeDetailsComponent,
} from "./components";
import { NgxEditorModule } from "ngx-editor";

@NgModule({
  declarations: [
    ChallengesListingPageComponent,
    CreateNewChallengeDetailsComponent,
    MilestoneSummaryViewComponent,
    SettingUpNewMilestoneConfigComponent,
    ChallengesMilestoneConfigComponent,
    ChallengesMilestoneConfigSetUpComponent,
    ChallengesRewardConfigComponent,
    ChallengeTypeSelectionComponent,
    GetChallengeDetailsPageComponent,
    GetTimeBasedChallengeDetailsComponent,
  ],
  imports: [
    SharedModule,
    ChallengesRoutingModule,
    NgxMaterialTimepickerModule,
    MatChipsModule,
    NgxEditorModule
  ],
})
export class ChallengesModule {}
